// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kU5O","content":"styles_content__1PUfG"};